import { render, staticRenderFns } from "./PopupHabitsAdd.vue?vue&type=template&id=49e598c8"
import script from "./PopupHabitsAdd.vue?vue&type=script&lang=js"
export * from "./PopupHabitsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports